"use client"

import { Toast } from "@base-ui/react/toast"
import { ToastList } from "@src/components/DefuseSDK/components/ToastList"
import type { ReactNode } from "react"

export function ToastProvider({ children }: { children: ReactNode }) {
  return (
    <Toast.Provider>
      {children}

      <Toast.Portal>
        <Toast.Viewport className="-translate-x-1/2 fixed top-3 left-1/2 z-1 mx-auto w-[calc(100vw-24px)] max-w-80 sm:w-full xl:top-5 xl:right-5 xl:left-auto xl:translate-x-0">
          <ToastList />
        </Toast.Viewport>
      </Toast.Portal>
    </Toast.Provider>
  )
}
